import axios from "axios";

const loadData = () => {
  //const url = `http://127.0.0.1:8000/ror/`;
  const url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/`;
  return axios.get(url);
};

const loadChars = () => {
  //const url = `http://127.0.0.1:8000/ror/careers`;
  const url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/careers`;
  return axios.get(url);
};

const loadHeroes = () => {
  //const url = `http://127.0.0.1:8000/ror/hero`;
  const url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/hero`;
  return axios.get(url);
};

const loadTrends = ({ hourFrom, hourTo, qty, weekday }) => {
  //const url = `http://127.0.0.1:8000/ror/hero`;
  let url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/campaign-trends`;
  url += "?hourTo=" + (hourTo - 1);
  url += "&hourFrom=" + hourFrom;
  url += "&qty=" + qty;

  if (weekday !== "All") {
    url += "&weekday=" + weekday;
  }

  return axios.get(url);
};

const loadRVRTrends = ({ timezone, realm }) => {
  //const url = `http://127.0.0.1:8000/ror/hero`;
  let url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/rvr-trends/?timezone=${timezone}`;
  url += "&realm=" + realm;

  return axios.get(url);
};

const loadCareerTrends = ({ career }) => {
  //const url = `http://127.0.0.1:8000/ror/hero`;
  let url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/career-trends/`;
  url += "?career=" + career;
  url += "&weekFrom=2023.04"; // + hourTo;
  //url += "&weekTo=2024.06"; // + hourFrom;

  return axios.get(url);
};

const loadGuilds = ({ combatType, weekTo, weekFrom, timezone }) => {
  //const url = `http://127.0.0.1:8000/ror/hero`;
  let url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/guilds/`;
  url += "?combatType=" + combatType;
  url += "&weekTo=" + weekTo;
  url += "&weekFrom=" + weekFrom;
  url += "&timezone=" + timezone;
  return axios.get(url);
};

const loadCareerStats = ({ combatType, solo, weekTo, weekFrom, timezone }) => {
  //let url = `http://127.0.0.1:8000/ror/career-stats/`;
  let url = `https://monkfish-app-8rhi3.ondigitalocean.app/ror/career-stats/`;
  url += "?combatType=" + combatType;
  url += "&soloKills=" + solo;
  url += "&limit=20000";
  url += "&weekTo=" + weekTo;
  url += "&weekFrom=" + weekFrom;
  url += "&timezone=" + timezone;

  return axios.get(url);
};

export {
  loadData,
  loadChars,
  loadCareerStats,
  loadHeroes,
  loadGuilds,
  loadTrends,
  loadCareerTrends,
  loadRVRTrends,
};
